<template>
    <v-app id="agentCom">
        <v-main>
            <v-container fluid>
                <v-row v-if="showParameters">
                    <v-col cols="2">
                        <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
                    </v-col>
                    <v-col cols="2">
                        <v-select v-model="agntCodesSelected" :items="agntCodes" item-value="agtnCode"  item-text="agtnNaam" label="Agents" multiple></v-select>
                    </v-col>
                </v-row>
                <v-row v-if="showParameters">
                    <v-col cols="2">
                        <v-menu v-model="dat1menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="param.van_dat" label="From date" v-on="on" readonly></v-text-field>
                            </template>
                            <v-date-picker v-model="param.van_dat2" :first-day-of-week="1" @input="param.van_dat = $moment(param.van_dat2).format('DD-MM-YYYY'); dat1menu = false"></v-date-picker>            
                        </v-menu>  
                    </v-col>
                    <v-col cols="2">
                        <v-menu v-model="dat2menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="param.tm_dat" label="Until date" v-on="on" readonly></v-text-field>
                            </template>
                            <v-date-picker v-model="param.tm_dat2" :first-day-of-week="1" @input="param.tm_dat = $moment(param.tm_dat2).format('DD-MM-YYYY'); dat2menu = false"></v-date-picker>
                        </v-menu>  
                    </v-col>
                </v-row>
                <v-row v-if="showParameters">  
                    <v-col cols="2">
                        <v-text-field v-model="lowerBoundary" label="Error below percentage" type="number" min="0" max="100" step="0.1" suffix="%"></v-text-field> 
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="upperBoundary" label="Error above percentage" type="number" min="0" max="100" step="0.1" suffix="%"></v-text-field> 
                    </v-col>
                </v-row>  
                <v-row>    
                    <v-col cols="11">
                        <v-btn class="primary ma-0 mx-2" small :disabled="submitted" @click="ovrz" v-if="showParameters">Check agent commission</v-btn>
                        <v-btn class="primary ma-0 mx-2" small :disabled="submitted" @click="showParameters=!showParameters" v-if="!showParameters">Show Parameters</v-btn>
                        <v-btn class="primary ma-0 mx-2" small :disabled="submitted" @click="allLines=!allLines" v-if="items.length>0">Toggle all lines</v-btn>
                        <v-btn class="primary ma-0 mx-2" small :disabled="submitted" @click="allAgents=!allAgents" v-if="items.length>0">Toggle all agents</v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-btn class="success ma-0 mx-0" small :disabled="submitted" @click="exportDataToExcel" v-if="items.length>0">Export to excel</v-btn>
                    </v-col> 
                </v-row>
                <v-divider class="my-2"></v-divider>
                <div v-if="showResult">
                    <v-row v-for="item in items" :key="item.eign_code" class="pa-0">
                        <v-col cols="12" class="font-weight-bold pa-2" v-if="allAgents||item.checks1>0||item.checks2">
                            <span @click="$router.open('/eign/onEign/' + item.eign_encrid)"><a>{{  item.eign_code }} </a></span> - {{ item.eign_naam }}
                        </v-col>
                        <v-col cols="12" class="pa-0 px-2" v-if="allAgents||item.checks1>0||item.checks2>0"><v-divider></v-divider></v-col>
                        <v-col cols="12" class="pa-0" v-if="allAgents||item.checks1>0||item.checks2">
                            <v-data-table 
                                :items="item.huovs" 
                                :items-per-page="-1" 
                                :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                                dense
                                :headers="headers">
                                <template v-slot:item="props">
                                    <tr v-if="allLines||props.item.grondslag_alert1||props.item.grondslag_alert2">
                                        <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid )"><a>{{ props.item.huov_code }} </a></td>
                                        <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid )"><a>{{ props.item.huis_code }} </a></td>
                                        <td>{{ props.item.cttp_nr }} {{ props.item.type }}</td>
                                        <td class="text-right">{{ props.item.grondslag }}</td>
                                        <td class="text-right">{{ props.item.test_commissie1 }}</td>
                                        <td class="text-right">{{ props.item.test_commissie2 }}</td>
                                        <td class="text-right">{{ props.item.regel_commissie }}</td>
                                        <td class="text-right">{{ props.item.commissie_perc }}</td>
                                        <td><v-btn class="primary ma-0 mx-2" x-small @click="showDetails(props.item)">Details</v-btn></td>
                                        <td>
                                            <span class="red--text font-weight-bold" v-if="props.item.grondslag_alert1">Check commission (high)</span>
                                            <span class="orange--text font-weight-bold" v-if="props.item.grondslag_alert2">Check commission (low)</span>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-col>
                        <v-col cols="12" class="pa-2" v-if="allAgents||item.checks1>0||item.check2>0"><v-divider></v-divider></v-col>
                    </v-row>
                </div>
            </v-container>
            <showProgress ref="showProgress"></showProgress>
        </v-main>
        <navBar title="Ares - Finance" :home="true" type="finance"/>
        <commissieDetails ref="commissieDetails"/>
    </v-app>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import showProgress from "@/components/showProgress.vue";
    import commissieDetails from "@/views/task/fin/ovrz/commissieDetails.vue";
    
    export default {
        components: {
            navBar,
            showProgress,
            commissieDetails,
        },
        data() {
            return {
                showParameters: true,
                showResult: false,
                dat1menu: false,
                dat2menu: false,
                submitted: false,
                allLines: false,
                allAgents: false,
                lowerBoundary: 1,
                upperBoundary: 5.5,
                param: {},
                agntCodes: [],
                agntCodesSelected: [],
                bedrCodes: [],
                bedrCodesSelected: [],

                items: [],
            }
        },
        computed: {
            upperHeader() {
                return this.upperBoundary + "%";
            },
            lowerHeader() {
                return this.lowerBoundary + "%";
            },
            headers() {
                return [
                    {text: "Rental contract", value: "huov_code", sortable: true, tdClass: ""},
                    {text: "Accommodation", value: "huis_code", sortable: true, tdClass: ""},
                    {text: "Contract type", value: "type", sortable: true, tdClass: ""},
                    {text: "Commission base", value: "grondslag", sortable: true, align: "end"},
                    {text: this.upperHeader, value: "test_commissie1", sortable: true, align: "end"},
                    {text: this.lowerHeader, value: "test_commissie2", sortable: true, align: "end"},
                    {text: "Commission", value: "regel_commissie", sortable: true, align: "end"},
                    {text: "Percentage", value: "commissie_num", sortable: true, align: "end"},
                    {text: "", value: "", sortable: false, tdClass: ""},
                    {text: "", value: "", sortable: false, tdClass: ""},
                ];
            }
        },
        mounted() {
            this.getParameters();
        },
        methods: {
            getParameters() {
                var iIndex=0;
                this.$axios.post("ares/json/ares/task/fin/ovrz/getAgentCom1Param.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAgentCom1Param"
                    },
                    getAgentCom1Param: {}
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.param = res.data.getAgentCom1Param; 

                        this.bedrCodes = this.param.bedrKeuzes;
                        for (iIndex=0; iIndex<this.param.bedrKeuzes.length; iIndex++) {
                            if (this.param.bedrKeuzes[iIndex].bedrSelected) {
                                this.bedrCodesSelected.push(this.param.bedrKeuzes[iIndex].bedrCode);
                            }
                        }
                        this.agntCodes = res.data.getAgentCom1Param.agtnKeuzes;
                    }
                });
            },
            ovrz() {
                this.submitted = true;
                this.showResult = false;
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/task/fin/ovrz/excelExportAgentComControle.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "excelExportAgentComControle"
                    },
                    excelExportAgentComControle: {
                        bedr_codes: this.bedrCodesSelected,
                        agnt_codes: this.agntCodesSelected,
                        //maandJaar: this.param.maandKeuze,
                        van_dat: this.param.van_dat,
                        tm_dat: this.param.tm_dat,
                        //destination: this.param.destKeuze
                        lowerBoundary: parseFloat(this.lowerBoundary),
                        upperBoundary: parseFloat(this.upperBoundary),
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.$refs.showProgress.close();
                        this.submitted = false;
                        this.showParameters = true;
                        // console.log(res.data.error);
                    } else {
                        this.$refs.showProgress.close();
                        this.submitted = false;
                        this.showResult = true;
                        this.showParameters = false;
                        // console.log(res.data);
                        this.items = res.data.excelExportAgentComControle;
                    }
                }).catch(error => {
                    this.$refs.showProgress.close();
                    this.showParameters = true;
                    this.submitted = false;
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: error,
                        color: "error",
                    });
                    // console.log(error);
                });
            },
            showDetails(huov) {
                this.$refs.commissieDetails.openDialog(huov);
            },
            exportDataToExcel(){
                var XLSX = require("xlsx");
                // Create a new workbook
                var wb = XLSX.utils.book_new();
                let lowerBoundary = this.lowerBoundary + '%';
                let upperBoundary = this.upperBoundary + '%';
                
                for(let agentNr = 0; agentNr < this.items.length; agentNr++) {
                    // Voor iedere agent een "eigen" tabblad
                    let e_commission=[];
                    for (let huovNr = 0; huovNr < this.items[agentNr].huovs.length; huovNr++) {
                        let huov = this.items[agentNr].huovs[huovNr];

                        let el = new Object();

                        el["RentalContract"]=huov.huov_code;
                        el["Accommodation"]=huov.huis_code;
                        el["ContractType"]=huov.type;

                        el["CommissionBase"]=huov.grondslag_nr;
                        el[lowerBoundary]=huov.test_commissie_nr1;
                        el[upperBoundary]=huov.test_commissie_nr2;
                        el["Commission"]=huov.regel_commissie_nr;
                        el["Percentage"]=huov.commissie_perc_nr;
    
                        e_commission.push(el);
                    }
                    // Maak een sheet van dit array
                    var ws = XLSX.utils.json_to_sheet(e_commission);
                    // append the sheet to the workbook
                    XLSX.utils.book_append_sheet(wb, ws, this.items[agentNr].eign_naam);
                }
                XLSX.writeFile(wb, "CommissionCheck.xlsx");
            }
        }
    };

</script> 
